import React from 'react';

const ToggleInput = ({handleToggle})=>{

     const [show,setShow] = React.useState(true);

     const cls = show ?'btn-outline-secondary' :'btn-outline-danger';

     return (
        <>
            <span 
                className ={`btn  ${cls} btn-sm rounded`}
                style = {{position:'absolute',right:'15px',top:'-8px'}}
                onClick = {()=>{
                    setShow(!show);
                    handleToggle();
                }}

            > 
        
                { 
                    show 
                    ? <i className ='fa fa-times'></i>
                    : <i className ='fa fa-list'></i>
                }

            </span>
        </>
     );

};

export default ToggleInput;